// src/components/page-renderer/PageRenderer.jsx
import React from "react";
import SectionRenderer from "./SectionRenderer";

export default function PageRenderer({ content }) {
  if (!content?.sections || content.sections.length === 0) return null;

  return (
    <div className="w-full">
      {content.sections.map((section) => (
        <SectionRenderer key={section.id} section={section} />
      ))}
    </div>
  );
}
